import getApiLocalPort from "./getApiLocalPort";

// Convenção de domínio: a API de uma instância atende em `api-` + host do front.
//   atlas-subway-homol.atmodigital.com -> api-atlas-subway-homol.atmodigital.com
//   atlas-subway.atmodigital.com       -> api-atlas-subway.atmodigital.com
// O roteamento por serviço passou a ser por CAMINHO no nginx (/user, /proposal, ...) —
// antes era um subdomínio por serviço, o que obrigava a embutir o domínio no build e
// impedia o mesmo build de servir mais de uma instância.

const API_PATH = {
  user: "user",
  security: "security",
  "master.data": "masterdata",
  proposal: "proposal",
  purchase: "purchase",
  "approval.flow": "approvalflow",
  "integration.omie": "integrationomie",
  stock: "stock",
};

const isLocal = () => window.location.hostname === "localhost";

// Em desenvolvimento a API pode estar noutro IP de loopback (ex. 127.0.0.2), para o
// projeto conviver com outro que usa as mesmas portas. Vem de .env.local, que o git
// ignora; sem a variavel, continua localhost.
const LOCAL_API_HOST = process.env.VUE_APP_LOCAL_API_HOST || "http://localhost";

// Porta local por servico, quando a padrao ja estiver ocupada por outro programa da
// maquina. Formato: "user=3010,stock=3017". Sem a variavel, vale o mapa de sempre.
const LOCAL_PORT_OVERRIDES = Object.fromEntries(
  (process.env.VUE_APP_LOCAL_API_PORTS || "")
    .split(",")
    .filter(Boolean)
    .map((par) => par.split("=").map((v) => v.trim()))
);

export function apiRoute(service) {
  if (isLocal()) {
    return `${LOCAL_API_HOST}:${LOCAL_PORT_OVERRIDES[service] || getApiLocalPort(service)}/`;
  }

  if (service === "websocket") {
    // socket.io interpreta caminho na URL como NAMESPACE, não como rota — então a do
    // websocket é só a origem da API; o nginx encaminha /socket.io/ para a porta 9024.
    return `https://api-${window.location.hostname}`;
  }

  return `https://api-${window.location.hostname}/${API_PATH[service]}/`;
}

export default function setApiRoutes(Vue) {
  Vue.prototype.$ipUser = apiRoute("user");
  Vue.prototype.$ipSecurity = apiRoute("security");
  Vue.prototype.$ipMasterData = apiRoute("master.data");
  Vue.prototype.$ipProposal = apiRoute("proposal");
  Vue.prototype.$ipPurchase = apiRoute("purchase");
  Vue.prototype.$ipApprovalFlow = apiRoute("approval.flow");
  Vue.prototype.$ipIntegrationOmie = apiRoute("integration.omie");
  Vue.prototype.$ipStock = apiRoute("stock");
  Vue.prototype.$ipWebSocket = apiRoute("websocket");
}
